export default __webpack_public_path__ + "static/media/buttons-edit.92a0dd4a.svg";